export default __webpack_public_path__ + "static/media/trustly_logo.adaca940.png";